/** @jsx jsx */

import { Fragment } from 'react';

import { Icon, Text } from '@zapier/design-system';
import { jsx } from '@emotion/core';

type Props = {
  isSuccess: boolean;
  text: string;
};

const Item = ({ isSuccess, text }: Props) => {
  return (
    <Fragment>
      <Icon
        color={isSuccess ? 'StatusSuccessWeaker' : 'GrayWarm4'}
        name={isSuccess ? 'formCheckCircle' : 'formRadioUnchecked'}
        size={18}
      />
      <Text margin="0px 0px 0px 5px">{text}</Text>
    </Fragment>
  );
};

export default Item;
